import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../../../store';

export default function useIntakeMedicationPageState() {
  const medications = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.intakeQuestionnaireDetails?.medications ?? [],
  );
  const hasNoMedications = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.intakeQuestionnaireDetails?.has_no_medications ?? false,
  );
  const isSaving = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.createMedicationLoading ||
      state.intakeQuestionnaire.updateMedicationLoading ||
      state.intakeQuestionnaire.deleteMedicationLoading ||
      state.intakeQuestionnaire.deleteAllMedicationsLoading ||
      state.intakeQuestionnaire.setHasNoMedicationsLoading,
  );
  // The bulk operations (delete all / toggle "no medication") must lock the checkbox and
  // list fields and hold the confirm dialog open, so they are exposed on their own rather
  // than only feeding the list progress bar via `isSaving`.
  const isBulkSaving = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.deleteAllMedicationsLoading ||
      state.intakeQuestionnaire.setHasNoMedicationsLoading,
  );

  return { medications, hasNoMedications, isSaving, isBulkSaving };
}
